import { ACCEPT_EXTENSIONS_STRING } from "@/constants";

interface HiddenFileInputProps {
  id: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  multiple?: boolean;
  accept?: string;
}

export const HiddenFileInput = ({
  id,
  onChange,
  disabled = false,
  multiple = false,
  accept = ACCEPT_EXTENSIONS_STRING,
}: HiddenFileInputProps) => {
  return (
    <input
      id={id}
      type="file"
      accept={accept}
      onChange={onChange}
      disabled={disabled}
      multiple={multiple}
      className="hidden"
    />
  );
};
